const cmFormatter = new Intl.NumberFormat('de-DE', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
})

/** Human-readable PDF page size for the storey image settings info tooltip. */
export const formatStoreyImagePdfPageSizeInfo = (
  transform: Pick<StoreyImageTransform, 'pdfPage' | 'pdfPageWidthCm' | 'pdfPageHeightCm'>,
): string | null => {
  const { pdfPage, pdfPageWidthCm, pdfPageHeightCm } = transform
  if (
    pdfPageWidthCm == null ||
    pdfPageHeightCm == null ||
    !Number.isFinite(pdfPageWidthCm) ||
    !Number.isFinite(pdfPageHeightCm)
  ) {
    return null
  }

  const size = `${cmFormatter.format(pdfPageWidthCm)} × ${cmFormatter.format(pdfPageHeightCm)} cm`
  if (pdfPage != null && Number.isFinite(pdfPage)) {
    return `PDF-Seite ${pdfPage}: ${size}`
  }

  return `PDF-Seite: ${size}`
}
